export const COOKIE_KEYS = {
  AI_CREDIT_ONBOARDING_COMPLETED: 'ai_credit_onboarding_completed'
} as const;

export function setCookie(key: string, value: string, days = 30): void {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${key}=${value};${expires};path=/`;
}

export function getCookie(key: string): string | null {
  const name = `${key}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  
  for (let cookie of cookieArray) {
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return null;
}

export function deleteCookie(key: string): void {
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export function hasCompletedAiCreditOnboarding(): boolean {
  return getCookie(COOKIE_KEYS.AI_CREDIT_ONBOARDING_COMPLETED) === 'true';
}

export function setAiCreditOnboardingCompleted(): void {
  setCookie(COOKIE_KEYS.AI_CREDIT_ONBOARDING_COMPLETED, 'true', 365); // 1년간 유지
}